'use strict';

/**
 * `itValidateLocation` directive.
 */
const saLocationValidator = [
  function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$validators.location = function (location) {
          return ngModel.$isEmpty(location) || angular.isObject(location) && location.placeId;
        };
      }
    };
  }
];

export default saLocationValidator;




// WEBPACK FOOTER //
// ./app/src/directives/location_validator.js